import { render, staticRenderFns } from "./msPaginationEditor.vue?vue&type=template&id=6cdd7b5e&scoped=true"
import script from "./msPaginationEditor.vue?vue&type=script&lang=js"
export * from "./msPaginationEditor.vue?vue&type=script&lang=js"
import style0 from "./msPaginationEditor.vue?vue&type=style&index=0&id=6cdd7b5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdd7b5e",
  null
  
)

export default component.exports